import React from "react";
import EvtMultiSelectBadges from "components/multiselect";
import { RenderProfile } from "components/render-profile";

/**
 * User multiselect wrapper for Directus employees collection.
 * Hides fields/searchKeys/mapItem wiring; exposes filter and UI props.
 */
export default function EvtUserMultiSelect({
  values = [],
  onChange,
  filter,
  placeholder = "Select",
  searchPlaceholder = "Search...",
  valueKey = "id",
  ...uiProps
}) {
  return (
    <EvtMultiSelectBadges
      collection="employees"
      values={values}
      onChange={onChange}
      valueKey={valueKey}
      // Default wiring for employees
      fields={["id", "first_name", "last_name", "avatar"]}
      searchKeys={["first_name", "last_name", "email"]}
      filter={filter}
      sort={["first_name"]}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      mapItem={(item) => ({
        value: item.id,
        label: <RenderProfile user={item} />,
        avatar: <RenderProfile user={item} />,
      })}
      {...uiProps}
    />
  );
}
